import { render, staticRenderFns } from "./BirthdaysStaffFreeDates.vue?vue&type=template&id=ff3dce46&scoped=true&"
import script from "./BirthdaysStaffFreeDates.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysStaffFreeDates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3dce46",
  null
  
)

export default component.exports